import React from 'react'
import App from './components/App'
import './styles/global.css'
import { createRoot } from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Router><App /></Router>);